import React from "react";
import { FormattedDate, FormattedTime } from 'react-intl'
export const DateColumnFormatter = (cellContent, row, props) => (
    <>
        {cellContent && cellContent != null && <FormattedDate value={cellContent} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />}
        {!cellContent && cellContent == null && ""}
    </>

    // <FormattedTime value={cellContent} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD"/>

);

export const DateTimeColumnFormatter = (cellContent, row, props) => (
    <>
        {cellContent && cellContent != null && <FormattedTime value={cellContent} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />}
        {!cellContent && cellContent == null && ""}

    </>
);


